export default `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
    <path d="M930.454 270.617l82.688-76.842q10.858-10.858 10.858-27.145t-10.858-27.981l-127.791-127.791q-12.529-10.858-27.563-10.858t-27.563 10.858l-78.512 81.018zM345.788 855.282l512.836-512.836-178.74-178.74-512.836 512.836zM0 1024l278.134-93.546-186.258-186.258z"></path>
</svg>
`;
